import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MButtonModule } from '@mercadona/components/button';
import { MTranslateModule } from '@mercadona/core/translate';

import { NoPermissionPageComponent } from './no-permission-page.component';

/**
 * NoPermissionPageModule
 */
@NgModule({
  declarations: [NoPermissionPageComponent],
  imports: [CommonModule, MTranslateModule, MButtonModule],
  exports: [NoPermissionPageComponent]
})
export class NoPermissionPageModule {}
